class Register {

  // Constructor
  constructor() {
    this.API_ENDPOINT = "https://www.sria.co.jp/apps/happynewyear2018/php/api";
  }

  /**
   * ハイスコアを取得するAPIのラッパー
   * @param  {Function} callback 成功時に実行するコールバック関数。第一引数に結果が入ってくる function(result) {〜}
   * @return {vold|boolean} エラー時のみfalse
   */
  getHighScore(callback) {
    $.ajax({
      type: 'GET',
      url: this.API_ENDPOINT + "/get.php",
      cache: false,
      data: {}
    }).done(function(data) {
      callback(data);
    }).fail(function(data, status, error) {
      console.log(status+":"+error);
      return false;
    });
  }

  /**
   * ハイスコアをセットするAPIのラッパー
   * @param  {Number}   score    スコア
   * @param  {Function} [callback] 必須ではない。成功時に実行するコールバック関数。第一引数に結果が入ってくる function(result) {〜}
   * @return {vold|boolean} エラー時、バリデーション失敗時のみfalse
   */
  setHighScore(score, callback) {

    if(!this.scoreValidation(score)) {
      return false;
    }

    $.ajax({
      type: 'POST',
      url: this.API_ENDPOINT + "/set.php",
      cache: false,
      async: false,
      data: {
        "score": score
      }
    }).done(function(data) {
      if(callback) {
        callback(data);
      }
    }).fail(function(data, status, error) {
      console.log(status+":"+error);
      return false;
    });
  }

  /**
   * スコアの書式バリデーション
   * @param  {Number} score スコア
   * @return {Boolean}
   */
  scoreValidation(score) {
      return /^[0-9]+$/.test(score);
  }
}

module.exports = Register;



// WEBPACK FOOTER //
// ./app/src/js/modules/register.js